import LoadingPresenter from '@components/Loading';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import qs from 'query-string';
import { useMediaQuery, useTheme } from '@material-ui/core';
import useIframe from '@hooks/useIframe';
import { isMobile } from 'react-device-detect';

export interface Message {
  key: 'index-page' | 'post-page' | 'posts-page' | 'category-page' | 'tag-page';
  payload: any;
}

const isLocalhost = window.location.href.includes('localhost');

const baseUrl = isLocalhost
  ? 'http://localhost:3000'
  : process.env.REACT_APP_BLOG_URL;

const MOBILE_GNB_HEIGHT = 48;
const MOBILE_BLOG_MENU_HEIGHT = 74;
const GNB_HEIGHT = 61;

const BlogIframe = () => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const [load, setLoad] = useState(false);

  const history = useHistory();
  const { postMessage } = useIframe();

  const { location } = history;
  const { slug, mainCategory, subCategory, tagName } = useParams() as {
    slug: string;
    mainCategory: string;
    subCategory: string;
    tagName: string;
  };

  const search = { ...qs.parse(location.search) };

  const isExtendedLink =
    Boolean(slug) ||
    Boolean(mainCategory) ||
    Boolean(subCategory) ||
    Boolean(tagName) ||
    search.hasOwnProperty('page');

  const extendedLink = () => {
    const link =
      baseUrl +
      `${location.pathname.replace('/blog', '')}${
        search.hasOwnProperty('page') ? `?${qs.stringify(search)}` : ''
      }`;

    if (slug && link.includes('/posts/')) {
      return link.replace(/\/posts/, '/post');
    }

    return link;
  };
  /**
   * 브라우저 뒤로가기 클릭 시
   */
  useEffect(() => {
    const listen = (e: PopStateEvent) => {
      postMessage({ iframeId: 'blog-iframe', message: { key: 'pop' } });
    };

    window.addEventListener('popstate', listen);

    return () => {
      window.removeEventListener('popstate', listen);
    };
  }, [postMessage]);

  /**
   * 블로그로부터 받은 메세지
   */
  useEffect(() => {
    const listener = (e: MessageEvent) => {
      const message = e.data as Message;

      switch (message.key) {
        case 'index-page': {
          return window.history.pushState({}, '', '/blog');
        }

        case 'post-page': {
          return window.history.pushState(
            {},
            '',
            `/blog/post/${message.payload}`
          );
        }
        case 'posts-page': {
          return window.history.pushState(
            {},
            '',
            `/blog/posts?${qs.stringify(message.payload)}`
          );
        }
        case 'tag-page': {
          return window.history.pushState(
            {},
            '',
            `/blog/tag/${message.payload}`
          );
        }
        case 'category-page': {
          return window.history.pushState(
            {},
            '',
            `/blog/category/${message.payload}`
          );
        }
      }
    };

    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);

  const computedHeight = matches
    ? isMobile
      ? MOBILE_GNB_HEIGHT + MOBILE_BLOG_MENU_HEIGHT
      : MOBILE_GNB_HEIGHT
    : GNB_HEIGHT;

  return (
    <>
      {!load && <LoadingPresenter open />}
      <iframe
        id="blog-iframe"
        onLoad={() => setLoad(true)}
        title="blog-iframe"
        allow="clipboard-write;"
        src={isExtendedLink ? extendedLink() : baseUrl}
        style={{
          width: '100vw',
          height: `calc(100vh - ${computedHeight}px)`
        }}
      />
    </>
  );
};

export default BlogIframe;
